export const ROTAS = {
  LOGIN: '/login',
  CADASTRO: '/cadastro',
  RECUPERAR_SENHA: '/recuperar-senha',
  EMAIL_VALIDATION: '/email-validation',

  DASHBOARD_ADMIN: '/home',
  GERENCIAMENTO_CAMPANHAS: '/campanhas',
  GERENCIAMENTO_CLIENTES: '/clientes',
  RELATORIOS: '/relatorios',
  CONFIGURACOES_SISTEMA: '/configuracao',
  GERENCIAMENTO_USUARIOS: '/usuarios',

  DASHBOARD_CAIXA: '/home',

  DASHBOARD_CLIENTE: '/home',
  CAMPANHAS_CLIENTE: '/campanhas',
  HISTORICO_TRANSACOES: '/historico',
  PERFIL_CLIENTE: '/perfil',
  UNIDADES_CLIENTE: '/unidades',

  ERRO: '/erro',
  NAO_ENCONTRADO: '*',
};